<template>
  <div>
    <discount-modification-list />
  </div>
</template>

<script>
import discountModificationList from './list.vue'

export default {
  components: {
    discountModificationList
  }
}
</script>
